export default function Contact() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative bg-gray-900 rounded-t-[48px] pt-24 pb-12">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Four column grid */}
        <div className="grid grid-cols-4 gap-16 mb-20">
          {/* Column 1 - Company Info */}
          <div>
            <h3 className="text-[32px] font-bold text-white mb-10">ELVIS DOO SABAC</h3>
            <p className="text-base text-gray-400 mb-16">Modern iOS Applications</p>
            <div className="w-16 h-0.5 bg-teal-500"></div>
          </div>

          {/* Column 2 - Address */}
          <div>
            <div className="text-xs uppercase text-white/50 tracking-[3px] mb-6">LOCATION</div>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl text-teal-500 mt-1"></i>
                <div>
                  <p className="text-lg text-white/90">JANKA VESELINOVICA 100</p>
                  <p className="text-lg text-white/90">Sabac, 271684</p>
                  <p className="text-lg text-white/90">Serbia</p>
                </div>
              </div>
            </div>
          </div>

          {/* Column 3 - Contact Methods */}
          <div>
            <div className="text-xs uppercase text-white/50 tracking-[3px] mb-6">CONTACT</div>
            <div className="space-y-6">
              <div>
                <div className="text-sm text-gray-400 mb-2">Email</div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-lg text-teal-500"></i>
                  <a href="mailto:info@elvisdoosabac.com" className="text-lg text-white/90 hover:text-teal-400 transition-colors cursor-pointer">
                    info@elvisdoosabac.com
                  </a>
                </div>
              </div>
              <div>
                <div className="text-sm text-gray-400 mb-2">Phone</div>
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-lg text-teal-500"></i>
                  <a href="tel:+18127753285" className="text-lg text-white/90 hover:text-teal-400 transition-colors cursor-pointer">
                    +1 8127753285
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Column 4 - Navigation */}
          <div>
            <div className="text-xs uppercase text-white/50 tracking-[3px] mb-6">NAVIGATE</div>
            <div className="space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-base text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact
              </button>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-16 border-t border-white/10">
          <p className="text-center text-sm text-white/40">
            © 2025 ELVIS DOO SABAC. All rights reserved. · <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white/60 transition-colors cursor-pointer">Website Builder</a>
          </p>
        </div>
      </div>
    </div>
  );
}
